import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/index.js";
import { Provider } from "react-redux";
import { PrimeReactProvider } from "primereact/api";

const root = ReactDOM.createRoot(document.getElementById("root"));
const value = {
  hideOverlaysOnDocumentScrolling: true,
};
root.render(
  <Provider store={store}>
    <PrimeReactProvider value={value}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </PrimeReactProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
